import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const LazyStudentLogInForm = React.lazy(
	() =>
		import(
			/* webpackChunkName: 'StudentLogInForm' */ './components/StudentLogInForm'
		)
);

export default () => {
	return {
		path: 'student-log-in',
		element: <AsyncLoading component={<LazyStudentLogInForm />} />,
	};
};
